export const identifyUser = (
  user: string | IdentifyPayload,
  params?: Record<string, string>,
) => {
  if (exponea) {
    exponea.identify(user, params);
  }
};

export const trackEvent = ({ name, properties = {} }: TrackEventPayload) => {
  if (exponea) {
    exponea.trackEvent({ name, properties });
  }
};

export const showWebLayer = (id) => {
  if (exponea) {
    exponea.showWebLayer(id);
  }
};
